import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Oficina } from 'src/app/classes/Oficina';
import { Pessoa } from 'src/app/classes/Pessoa';
import { OficinaService } from 'src/app/services/oficina.service';
import { UtilsService } from 'src/app/utils/utils.service';

@Component({
  selector: 'app-oficina-forms',
  templateUrl: './oficina-forms.component.html',
  styleUrls: ['./oficina-forms.component.scss']
})
export class OficinaFormsComponent implements OnInit {

  @Output() fecharFormsEvent = new EventEmitter<any>();
  @Input() id:number;
  @Input() inserindo: boolean;
  oficina: Oficina;
  carregando: boolean = false;
  form: any;
  public isSubmit: boolean;

  @Input() fornecedores: Pessoa[] = [];

  constructor(
    private oficinaService: OficinaService,
    private translate: TranslateService,
    private utils : UtilsService) {}

  ngOnInit() {
    this.oficina = new Oficina();
    if(this.inserindo)
      this.oficina = new Oficina()
    else
      this.selecionarOficina();
  }

  selecionarOficina() {
    this.carregando = true;
    this.oficinaService.ObterPorId(this.id).subscribe(res =>{
      this.oficina = res;
      this.carregando = false;
    },
    ex =>{
      this.utils.getErro(ex);
      this.carregando = false;
    })
  }

  save(form: any) {
    if (!form.valid) {
      this.isSubmit = true;
      return;
    }
    this.carregando = true;

    if (this.oficina.IsTerceiro && !this.oficina.FornecedorId){
      this.utils.handleErro(this.translate.instant('DEVE_INFORMAR_UM_FORNECEDOR'))
      this.carregando = false;
      return;
    }

    if(this.oficina.Id > 0){
      this.oficinaService.Atualizar(this.oficina.Id, this.oficina).subscribe(
        res => {
          this.utils.handleSuccess(this.translate.instant('OFICINA_ALTERADA'));
          this.carregando = false;
          this.fecharFormsEvent.emit();
        },
        err => {
          this.utils.getErro(err);
          this.carregando = false;
        });
      }
    else{

      this.oficinaService.Inserir(this.oficina).subscribe(
        res => {
          this.utils.handleSuccess(this.translate.instant('OFICINA_CADASTRADA'));
          this.carregando = false;
          this.fecharFormsEvent.emit();
        },
        err => {
          this.utils.getErro(err);
          this.carregando = false;
        });
      }
  }

  cancelar(){
    this.fecharFormsEvent.emit();
  }

}